const SAFE_CHART_TYPES = new Set([
    'area',
    'bar',
    'bubble',
    'column',
    'heatmap',
    'line',
    'pie',
    'scatter',
    'spline',
    'treemap',
]);

const FORBIDDEN_KEYS = new Set([
    '__proto__',
    'constructor',
    'events',
    'footerformat',
    'format',
    'formatter',
    'headerformat',
    'href',
    'pointformat',
    'pointformatter',
    'prototype',
    'renderto',
    'src',
    'url',
    'usehtml',
]);

// Match the backend list of DOM event-handler attributes — narrow set so
// innocent keys like "online" or "once" aren't dropped from chart configs.
const FORBIDDEN_EVENT_HANDLER_KEYS = new Set([
    'onabort',
    'onblur',
    'onchange',
    'onclick',
    'onerror',
    'onfocus',
    'oninput',
    'onkeydown',
    'onkeypress',
    'onkeyup',
    'onload',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup',
    'onreset',
    'onscroll',
    'onselect',
    'onsubmit',
    'ontouchend',
    'ontouchmove',
    'ontouchstart',
    'onunload',
    'onwheel',
]);

const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const isUnsafeString = value => {
    const normalized = value.toLowerCase();
    return (
        normalized.includes('javascript:') || normalized.includes('data:text/html') || normalized.includes('<script')
    );
};

const sanitizeValue = value => {
    if (Array.isArray(value)) {
        return value.map(sanitizeValue);
    }

    if (isPlainObject(value)) {
        return Object.keys(value).reduce((result, key) => {
            const normalizedKey = key.toLowerCase();
            if (FORBIDDEN_KEYS.has(normalizedKey) || FORBIDDEN_EVENT_HANDLER_KEYS.has(normalizedKey)) {
                return result;
            }
            result[key] = sanitizeValue(value[key]);
            return result;
        }, {});
    }

    if (typeof value === 'string') {
        if (isUnsafeString(value)) {
            return '';
        }
        return value;
    }

    return value;
};

export const sanitizeHighchartsConfig = config => {
    if (!isPlainObject(config)) return null;

    const chartType = config.chart && typeof config.chart.type === 'string' ? config.chart.type.toLowerCase() : null;
    if (!chartType || !SAFE_CHART_TYPES.has(chartType)) return null;
    if (!Array.isArray(config.series)) return null;

    const sanitized = sanitizeValue(config);
    // Highcharts and the downstream `=== 'heatmap'` check both require lowercase.
    sanitized.chart = { ...sanitized.chart, type: chartType };
    return sanitized;
};
